import request from '@/utils/request'

export function queryTenderList(data) {
  return request({ url: '/crmTender/list', method: 'post', data: data || {} })
}

export function queryTenderStats(scope) {
  return request({ url: '/crmTender/stats', method: 'get', params: scope ? { scope } : {} })
}

export function queryTenderAnalysis(range) {
  return request({ url: '/crmTender/stats/analysis', method: 'get', params: range ? { range } : {} })
}

export function queryTenderSources() {
  return request({ url: '/crmTender/sources', method: 'get' })
}

export function queryTenderDetail(id) {
  return request({ url: `/crmTender/detail/${id}`, method: 'get' })
}

export function claimNextTender() {
  return request({ url: '/crmTender/claimNext', method: 'post' })
}

export function claimTender(id) {
  return request({ url: `/crmTender/claim/${id}`, method: 'post' })
}

export function assignTender(data) {
  return request({ url: '/crmTender/assign', method: 'post', data })
}

export function releaseTender(id) {
  return request({ url: `/crmTender/release/${id}`, method: 'post' })
}

export function reviewTender(data) {
  return request({ url: '/crmTender/review', method: 'post', data })
}

export function queryTenderContactRecords(id) {
  return request({ url: `/crmTender/contactRecords/${id}`, method: 'get' })
}

export function addTenderContactRecord(data) {
  return request({ url: '/crmTender/contactRecords', method: 'post', data })
}

export function convertTenderClue(data) {
  return request({ url: '/crmTender/convertClue', method: 'post', data })
}
